import {
  Input,
  useRef,
  useState,
  useEffect,
  getProjects,
  booleanOptions,
  MultiSearchForm,
  useDebouncedSearch,
} from "@";
import { searchValues } from "../utils/options";

const MultiSearch = ({ onSubmit, search, updateSearch, dataLength }) => {
  const hasFetchedData = useRef(false);
  const [projects, setProjects] = useState([]);

  useDebouncedSearch(onSubmit, search.values, searchValues);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  const fetchData = async () => {
    try {
      const { data: projects } = await getProjects(1, null, null);
      setProjects(
        projects?.data?.map(({ title }) => ({
          value: title,
          label: title,
        })),
      );
    } catch (error) {}
  };

  useEffect(() => {
    if (dataLength > 0 && !hasFetchedData.current) {
      fetchData();
      hasFetchedData.current = true;
    }
  }, [dataLength]);

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form xl:grid-cols-5"
      reset={() => updateSearch({ values: searchValues })}
    >
      <Input
        star
        label=" المشاريع"
        type="select-searchable"
        list={projects}
        value={projects?.filter((c) => search.values.projectTitle == c.value)}
        change={(e) => handleInputChange("projectTitle", e ? e.value : null)}
      />

      <Input
        star
        label="فعال"
        type="select"
        list={booleanOptions}
        value={search.values.isStopped}
        change={(e) => handleInputChange("isStopped", e.target.value)}
      />

      <Input
        star
        showTimeSelect
        type="date-range"
        labelA="من تاريخ"
        labelB="الي تاريخ"
        style="xl:col-span-2"
        valueB={search.values.toDate}
        valueA={search.values.fromDate}
        changeA={(e) => handleInputChange("fromDate", e)}
        changeB={(e) => handleInputChange("toDate", e)}
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
